import React from "react";

const AGB = () => {
  return (
    <div className="bg-white py-32 px-6 lg:px-8">
      <h2 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
        Allgemeine Nutzungsbedingungen für Dealersonly.parts
      </h2>
      <p className="mt-10 text-base leading-7 text-gray-700 ">
        Diese Nutzungsbedingungen gelten ab der Registrierung des Händlers auf
        der Seite Dealersonly.parts
      </p>
      <p className="mt-10 text-base leading-7 text-gray-700 ">
        Abu-Jo Trading, Schützenstrasse 44, 40723 Hilden, betreibt unter der
        Bezeichnung „Dealersonly.parts“ eine Deutsch und englischsprachige
        Website zum Verkauf von Ersatzteilen, Motorräder und das Erstellen von
        Suchanfragen für Teile & Motorräder
      </p>
      <p className="mt-10 text-base leading-7 text-gray-700 ">
        Diese Allgemeinen Nutzungsbedingungen enthalten die Regeln für die
        Nutzung der Webseite Dealersonly.parts. Wenn Sie die Dealersonly.parts
        Dienste als akreditierter und registrierter Händler nutzen und Verträge
        über kostenpflichtige Leistungen mit Dealersonly.parts abschließen,
        haben Sie ein gesetzliches Widerrufsrecht, über das Dealersonly.parts
        wie folgt belehrt:
      </p>
      <h3 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">
        Hinweise zur Einstellung von Produkten auf Dealersonly.parts
      </h3>
      <ul
        role="list"
        className="mt-8 space-y-2 text-gray-600 list-disc list-inside"
      >
        <li>Geben Sie Ihre Anzeige nur einmalig auf.</li>
        <li>
          Bitte bieten Sie ein konkretes Produkt an. Das Produkt muss in der
          Überschrift und im Anzeigentext klar beschrieben werden.
        </li>
        <li>Bieten Sie nur Produkte an, die sich in Ihrem Besitz befinden.</li>
        <li>Nutzen Sie nur eigene Fotos und Texte.</li>
        <li>Geben Sie einen realistischen Preis an.</li>
        <li>Verfassen Sie Ihre Anzeigen auf Deutsch oder auf Englisch.</li>
        <li>
          Benutzen Sie so viele Bestellnummern der verschiedenen Anbieter
          (inklusive der OEM Nummer) wie möglich
        </li>
        <li>
          Jeder Teilnehmer kann nur unter einer E-Mail Adresse registriert
          werden
        </li>
      </ul>
      <p className="mt-10 text-base leading-7 text-gray-700 ">
        Nicht erlaubt ist:
      </p>
      <ul
        role="list"
        className="mt-8 space-y-2 text-gray-600 list-disc list-inside"
      >
        <li>
          Das Teilen von Inhalten (auch via Nachricht), die gegen gesetzliche
          Vorschriften oder die gute Sitte verstoßen.
        </li>
        <li>
          Die Verwendung von sogenannten "Wegwerfadressen" für das Versenden von
          Nachrichten oder Schalten von Anzeigen.
        </li>
        <li>
          Die Angabe von Kontaktdaten im Beschreibungstext sind nicht zulässig-
          der Interessent bekommt die Angaben des Verkäufers automatisch
          angezeigt
        </li>
        <li>
          Das Schalten von Kontaktanzeigen und Tätigkeiten mit sexuellem
          Hintergrund.
        </li>
        <li>
          Es ist nicht gestattet, Nacktbilder oder pornografische Bilder in
          Anzeigen einzufügen.
        </li>
        <li>
          Bitte achten Sie auf die Formulierung des Anzeigentextes und vermeiden
          Sie eine unangemessene Ausdrucksweise, Beschimpfungen, Warnungen,
          Hinweise oder Aufrufe.
        </li>
      </ul>
      <p className="mt-10 text-base leading-7 text-gray-700 ">
        Eine Anzeige, die gegen unsere Grundsätze verstößt, wird gelöscht.
        Sollte es sich dabei um eine kostenpflichtige Anzeige handeln, welche
        aufgrund eines Verstoßes von der Seite entfernt wird, werden die
        Gebühren für diese Anzeige nicht erstattet.
      </p>
      <h3 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">
        Unzulässige Artikel
      </h3>
      <p className="mt-10 text-base leading-7 text-gray-700 ">
        Der Handel mit Produkten bei Dealersonly.parts ist prinzipiell zulässig,
        wenn der Handel mit diesen Produkten nicht gegen nationale oder
        internationale Gesetzgebung verstößt. Darüber hinaus gibt es spezielle
        Grundsätze für die Nutzung von Dealersonly.parts.
      </p>
      <p className="mt-10 text-base leading-7 text-gray-700 ">
        Achtung! Diese Liste erhebt keinen Anspruch auf Vollständigkeit. Als
        Nutzer sind Sie selbst für Ihr Handeln auf der Plattform verantwortlich.
        Bitte achten Sie auf die geltenden gesetzlichen Bestimmungen bezüglich
        Ihrer Angebote.
      </p>
      <p className="mt-10 text-base leading-7 text-gray-700 ">
        Es ist untersagt, folgende Produkte anzubieten oder in Anzeigen zu
        beschreiben:
      </p>
      <ul
        role="list"
        className="mt-8 space-y-2 text-gray-600 list-disc list-inside"
      >
        <li>Aufrufe zu Straftaten (z. B. Beleidigungen, Gewalttaten)</li>
        <li>Aufrufe zu Geldspenden</li>
        <li>Beleidigungen, Beschimpfungen, Rufmord, Diskriminierung</li>
        <li>Rassenhass verbreitende oder verfassungsfeindliche Propaganda</li>
        <li>Gemeingefährliche Aktivitäten</li>
        <li>
          Artikel mit einer Altersfreigabe ab 18 Jahren, Tabakwaren aller Art,
          sowie entsprechendes Zubehör wie z.B. Shishas oder Pfeifen
        </li>
        <li>Alkoholische Getränke</li>
        <li>
          Drogen im Sinne des Betäubungsmittelgesetzes und andere
          bewusstseinsverändernde Stoffe, sowie entsprechendes Zubehör
        </li>
        <li>Gefährliche oder eingeschränkt handelbare Gegenstände</li>
        <li>Gestohlene Gegenstände</li>
        <li>
          Alle Gegenstände mit Symbolen verfassungsfeindlicher Organisationen -
          auch nicht sichtbar dargestellte (verdecktes Hakenkreuz)
        </li>
        <li>
          Waffen im Sinne des Waffengesetzes, insbesondere Schuss-, Hieb- und
          Stichwaffen jeglicher Art, sowie Zubehör und Munition jeglicher Art
        </li>
        <li>
          Nachahmungen und Fälschungen (Geld, Briefmarken, Bekleidung,
          Elektronikartikel, Accessoires Produkte, etc.)
        </li>
        <li>
          Ungenehmigte Kopien geschützter Werke oder Gegenstände, insbesondere
          Kopien von Filmen, Videospielen, Büchern (ebooks) oder Musik
        </li>
        <li>Paintball inkl. Ausrüstung (Kleidung ist erlaubt)</li>
        <li>
          Gegenstände, Kleidungsstücke und Ausweise aus sicherheitsrelevanten
          Bereichen (z. B. behördliche Ausweise und behördlich getragene
          Uniformen)
        </li>
        <li>
          Medizinische Instrumente (u.a. Röntgengeräte, Defibrillator,
          Ultraschall-/Sonographiegeräte)
        </li>
        <li>
          Arzneimittel (apothekenpflichtig und freiverkäuflich),
          Diätpräparate/Nahrungsergänzungsmittel sowie Medikamente für Tiere
        </li>
        <li>Parfum, außer leere Flakons, Factice</li>
        <li>Getragene Unterwäsche (insbesondere Unterhosen)</li>
        <li>
          Radioaktive Stoffe, Gift- und Explosivstoffe (Feuerwerkskörper,
          pyrotechnische Gegenstände), sowie sonstige gesundheitsschädigende
          Chemikalien
        </li>
        <li>
          Gaskartuschen oder Gasgrill mit Gaskartuschen, Gasflaschen (leer und
          voll)
        </li>
        <li>Pestizide</li>
        <li>Ausgebaute Airbags</li>
        <li>Menschliche Organe, Blut, sowie andere Körperflüssigkeiten</li>
        <li>
          Listen, Verzeichnisse o. ä., die Hersteller-, Händler- und
          Lieferantenadressen enthalten
        </li>
        <li>
          Gebührenpflichtige Telefondienste (SMS-Dienste, 0900-Nummern,
          Faxabrufe etc.)
        </li>
        <li>Bootleg-Aufnahmen (Raubpressungen)</li>
        <li>Angebote zum Herunterladen von Medien</li>
        <li>Spiele Accounts, Spielepunkte &amp; Coins</li>
        <li>Hard- oder Software zum Decodieren von Pay-TV</li>
        <li>
          Hard- oder Software zum Modifizieren von Spielekonsolen oder
          Mobilfunktelefonen
        </li>
        <li>
          Wertpapiere (insbesondere Aktien), Geldmarkt- oder Finanzinstrumente,
          Kredite, Darlehen und Finanzierungshilfen
        </li>
        <li>
          Schuldscheine und gerichtliche Titel, sowie andere Forderungen aus
          Rechtsgeschäften
        </li>
        <li>Archäologische Funde</li>
        <li>
          Handel mit Elfenbein und allen Elfenbeinprodukten, und zwar unabhängig
          von der Herkunft des Elfenbeins oder Elfenbeinproduktes inkl.
          prähistorisches Elfenbein.
        </li>
      </ul>

      <h3 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">
        Widerrufsbelehrung
      </h3>

      <p className="mt-10 text-base leading-7 text-gray-700 ">
        <strong>Widerrufsrecht</strong>
      </p>

      <p className="mt-10 text-base leading-7 text-gray-700 ">
        Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen
        diesen Vertrag zu widerrufen.
      </p>

      <p className="mt-10 text-base leading-7 text-gray-700 ">
        Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des
        Vertragsabschlusses.
      </p>

      <p className="mt-10 text-base leading-7 text-gray-700 ">
        Um Ihr Widerrufsrecht auszuüben, müssen Sie uns Dealersonly.parts
        E-Mail: rasi1340@t-online.de mittels einer eindeutigen E-Mail über Ihren
        Entschluss, diesen Vertrag zu widerrufen, informieren.
      </p>

      <p className="mt-10 text-base leading-7 text-gray-700 ">
        Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung
        über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist
        absenden.
      </p>

      <p className="mt-10 text-base leading-7 text-gray-700 ">
        <strong>Widerrufsfolgen</strong>
      </p>

      <p className="mt-10 text-base leading-7 text-gray-700 ">
        Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die
        wir von Ihnen erhalten haben, unverzüglich und spätestens binnen
        vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über
        Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese
        Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der
        ursprünglichen Transaktion eingesetzt haben.
      </p>

      <p className="mt-10 text-base leading-7 text-gray-700 ">
        <strong>Besondere Hinweise</strong>
      </p>

      <p className="mt-10 text-base leading-7 text-gray-700 ">
        Ihr Widerrufsrecht erlischt vorzeitig, wenn wir die geschuldete
        Dienstleistung vollständig erbracht haben und mit der Ausführung der
        Dienstleistung erst begonnen haben, nachdem Sie dazu Ihre ausdrückliche
        Zustimmung gegeben haben und gleichzeitig Ihre Kenntnis davon bestätigt
        haben, dass Sie Ihr Widerrufsrecht bei vollständiger Vertragserfüllung
        durch uns verlieren.
      </p>

      <h3 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">
        Leistungsbeschreibung und Bewerbung der Anzeigen
      </h3>
      <ol
        role="list"
        className="mt-8 space-y-2 text-gray-600 list-disc list-inside"
      >
        <li>
          Dealersonly.parts stellt einen Online-Service zur Verfügung, über den
          der Nutzer als Inserent aus Texten und Bildern bestehende Angebote und
          Gesuche erstellen und veröffentlichen sowie als Interessent
          veröffentlichte Anzeigen anderer Nutzer einsehen kann.
        </li>
        <li>
          Soweit dies zur Konvertierung in für die Dealersonly.parts taugliche
          Dateiformate erforderlich ist, wird Dealersonly.parts die Anzeigen des
          Nutzers in Formate für die Nutzung in mobilen Anwendungen und
          Webseiten konvertieren.
        </li>
        <li>
          Dealersonly.parts Dienste dienen dem Veröffentlichen von Anzeigen und
          dem Zusammenführen von Anbietern und Interessenten der eingestellten
          Waren. Dealersonly.parts ist selbst nicht Anbieter der jeweils mit den
          Anzeigen beworbenen Produkte.
        </li>
        <li>
          Im Rahmen der Anzeigendarstellung zeigt Dealersonly.parts wichtige
          Angaben zum Verkäufer der Ware
        </li>
        <li>
          Dealeronly.parts ist für jeden Nutzer kostenfrei zur Einreichung von
          Beschwerden und anderen Anfragen zugänglich und betreibt hierzu für
          gewerbliche Nutzer auch ein internes Beschwerdemanagementsystem. Der
          Kundenservice bearbeitet eingereichte Beschwerden, prüft diese
          sorgfältig und wird die ggfs. erforderlichen Maßnahmen umgehend
          ergreifen und den Nutzer hierüber bzw. über das Ergebnis des
          Beschwerdeverfahrens informieren.
        </li>
        <li>
          Dealersonly.parts ermöglicht es den Nutzern, die Suchergebnisse anhand
          verschiedener Kriterien zu sortieren (bspw. OEM Nummer, Aftermarket
          Nummer, Beschreibung usw.)
        </li>
      </ol>
      <h3 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">
        Registrierung, Nutzerkonto
      </h3>
      <ol
        role="list"
        className="mt-8 space-y-2 text-gray-600 list-disc list-inside"
      >
        <li>
          Für die vollständige Nutzung der Dealersonly.parts Dienste,
          insbesondere für das Einstellen von Anzeigen, das Anzeigen bestimmter
          Kontaktdaten von Inserenten ist eine Registrierung des Nutzers bei
          Dealersonly.parts erforderlich. Voraussetzung für eine Registrierung
          ist, dass es sich bei dem Nutzer um eine gewerbliche, juristische
          Person oder Personengesellschaft handelt. Ausdrücklich keine
          Privatanbieter zugelassen
        </li>
        <li>
          Der Nutzer ist verpflichtet, die bei der Registrierung von
          Dealersonly.parts erhobenen Daten wahrheitsgemäß und vollständig
          anzugeben. Bei einer Änderung der Daten nach erfolgter Registrierung
          ist der Nutzer verpflichtet, die Daten unverzüglich im
          passwortgeschützten Nutzerbereich der Dealersonly.parts -Dienste
          selbst zu aktualisieren.<br></br>
          Mit dem Absenden des Registrierungsformulars gibt der Nutzer ein
          Angebot auf den Abschluss einer Nutzungsvereinbarung mit
          Dealersonly.parts ab, mit dem er die Geltung der Nutzungsbedingungen
          akzeptiert sowie die Kenntnisnahme der Datenschutzerklärung erklärt.
          Akzeptiert Dealersonly.parts die Registrierung, erhält der Nutzer eine
          Bestätigungs-E-Mail mit einem personalisierten Link. Mit Zugang der
          Bestätigungs-E-Mail kommt zwischen Dealersonly.parts und dem Nutzer
          ein Vertrag über die Nutzung der Dealersonly.parts -Dienste (im
          Folgenden „Nutzungsvertrag“) zustande. Um die Registrierung
          abzuschließen, muss der Nutzer den mit der Bestätigungs-E-Mail
          mitgeteilten Link aufrufen und so seine E-Mail-Adresse verifizieren.
          Ein Anspruch auf Abschluss eines Nutzungsvertrages besteht nicht.
        </li>
        <li>
          Mit erfolgreicher Registrierung wird für den Nutzer ein Nutzerkonto
          angelegt, auf das er mit Hilfe seiner E-Mail-Adresse und seines bei
          der Registrierung gewählten Passwortes zugreifen kann. Das Passwort
          kann vom Nutzer jederzeit über den passwortgeschützten Nutzerbereich
          geändert werden. Es ist vom Nutzer geheim zu halten und vor dem
          Zugriff durch unbefugte Dritte geschützt aufzubewahren. Stellt der
          Nutzer fest oder hegt er den Verdacht, dass seine Zugangsdaten von
          einem Dritten unbefugt genutzt werden, hat er dies Dealersonly.parts
          unverzüglich mitzuteilen und sein Passwort unverzüglich zu ändern.
        </li>
        <li>
          Jeder Nutzer kann ausschließlich nur gewerbliche bzw. freiberufliche
          Nutzung (“gewerbliche Nutzer”) der Dealersonly.parts -Dienste jeweils
          nur einmal registrieren. Nutzerkonten sind nicht übertragbar.
        </li>
        <li>
          Dealersonly.parts behält ferner sich vor, zwecks Verbesserung des
          Nutzererlebnisses neue oder veränderte Funktionen und Features zu
          testen.
        </li>
        <li>
          Der Nutzer erhält auf seiner Nutzerprofilseite eine Übersicht der von
          ihm veröffentlichten Anzeigen. Zudem erhält er Informationen über
          seine Aktivitätsindikatoren und kann Änderungen an seinen
          Einstellungen, Präferenzen und Daten vornehmen.
        </li>
        <li>
          Im Rahmen der Dealersonly.parts -Dienste hat Dealersonly.parts Zugang
          zu Informationen über Nutzer, einschließlich personenbezogener Daten,
          die im Rahmen des abgeschlossenen Registrierung den Diensten die auf
          Dealersonly.parts angeboten werden dienlich sind.
        </li>
      </ol>
      <h3 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">
        Abschluss von Anzeigen
      </h3>
      <ol
        role="list"
        className="mt-8 space-y-2 text-gray-600 list-disc list-inside"
      >
        <li>
          Hat sich der Nutzer erfolgreich bei Dealersonly.parts registriert, hat
          er die Möglichkeit, über die Dienste eigene Anzeigen zu erstellen oder
          einen Suchauftragaufgeben und in der Dealersonly.parts Webseite zu
          veröffentlichen. Dealersonly.parts behält sich vor, Anzeigen in nur
          gegen Zahlung eines Entgeltes zu veröffentlichen.
        </li>
        <li>
          Mit Eingabe der Anzeige-Daten, hat der Anbieter gegenüber
          Dealersonly.parts ein verbindliches Angebot zum Abschluss eines
          Vertrages zugestanden und kann jederzeit in seinem Passwort
          geschützten Bereich seine Angaben ändern, korrigieren oder löschen –
          die Erhöhung des Warenwertes in nachhinein ist nicht zulässig und
          möglich das die Einstellgebühr sich danach richtet.
        </li>
        <li>
          Dealersonly.parts kann das Angebot zum Abschluss eines
          Anzeigenvertrages durch eine gesonderte Erklärung gegenüber dem Nutzer
          oder durch Freischaltung der Anzeige annehmen. Mit Annahme des
          Angebotes durch Dealersonly.parts kommt der Anzeigenvertrag zustande.
          Dealersonly.parts ist nicht zur Annahme von Vertragsangeboten des
          Nutzers verpflichtet.
        </li>
        <li>
          Die Anzeigendaten werden jeweils elektronisch gespeichert. Der Nutzer
          kann seine Anzeigen im passwortgeschützten Nutzerbereich verwalten,
          insbesondere dort auch löschen.
        </li>
        <li>
          Auch nach dem Zustandekommen eines Anzeigenvertrages ist es aus
          technischen Gründen möglich, dass die Anzeige nicht unmittelbar nach
          dem Freischalten über die Kategoriensuche oder mit Hilfe von
          Suchbegriffen innerhalb der Dealersonly.parts -Dienste aufgefunden
          werden kann.
        </li>
        <li>
          Im Falle eines Rechnungsversandes erfolgt diese ausschließlich auf
          elektronischem Weg.
        </li>
      </ol>
      <h3 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">
        Inhaltliche Anforderungen an eingestellte Anzeigen
      </h3>
      <ol
        role="list"
        className="mt-8 space-y-2 text-gray-600 list-disc list-inside"
      >
        <li>
          Der Nutzer ist verpflichtet, jede Anzeige in die jeweils passende
          Kategorie einzustellen und sein jeweiliges Angebot unter Angabe aller
          relevanten Merkmale und Eigenschaften mit Worten und möglichst genau,
          mit Bestellnummern zu beschreiben
        </li>
        <li>
          Das Einstellen von Anzeigen, Texten, Bildern oder sonstigen Inhalten,
          die gegen gesetzliche Bestimmungen, diese Nutzungsbedingungen, Rechte
          Dritter oder gegen die guten Sitten verstoßen, ist untersagt.
          Insbesondere ist es verboten, Inhalte einzustellen,
          <ul
            role="list"
            className="mt-8 space-y-2 text-gray-600 list-disc list-inside"
          >
            <li>
              die gegen urheber-, marken- und wettbewerbsrechtliche Vorschriften
              oder gegen gesetzliche Bestimmungen zum Jugendschutz verstoßen,
            </li>
            <li>
              die gegen die Grundsätze von Dealersonly.parts bezüglich
              verbotener Inhalte verstoßen, oder
            </li>
            <li>
              die unwahre Angaben enthalten oder die sonst irreführend sind.
            </li>
          </ul>
        </li>
        <li>
          Nutzer, die die Dealersonly.parts -Dienste als gewerbliche Anbieter
          nutzen unterliegen besonderen gesetzlichen Regelungen. Sie sind u. a.
          dazu verpflichtet, die gesetzlichen Informationspflichten zu erfüllen.
          Dealersonly.parts übernimmt keine Gewähr für die Richtigkeit und
          Vollständigkeit der dort zusammengefassten Angaben.
        </li>
      </ol>
      <h3 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">
        Besondere Pflichten des Nutzers
      </h3>
      <ol
        role="list"
        className="mt-8 space-y-2 text-gray-600 list-disc list-inside"
      >
        <li>
          Der Nutzer ist verpflichtet, alle Handlungen zu unterlassen, die den
          sicheren Betrieb der Dealersonly.parts -Dienste gefährden oder andere
          Nutzer belästigen könnten oder die sonst über eine bestimmungsgemäße
          Nutzung der Dienste hinausgehen. Er ist insbesondere verpflichtet, es
          zu unterlassen:
          <ul
            role="list"
            className="mt-8 space-y-2 text-gray-600 list-disc list-inside"
          >
            <li>
              E-Mail-Werbung, SMS-Werbung, Kettenbriefe oder andere belästigende
              Inhalte zu versenden
            </li>
            <li>Viren oder andere Technologien zu versenden</li>
            <li>
              Informationen, insbesondere E-Mail-Adressen oder Rufnummern, über
              andere Nutzer ohne die vorherige Einwilligung der Nutzer zu
              sammeln bzw. zu verwenden
            </li>
          </ul>
        </li>
        <li>
          Der Nutzer ist verpflichtet, alle innerhalb der Dealersonly.parts
          -Dienste gespeicherten Daten und Informationen, die er zu Zwecken der
          Beweissicherung, Buchführung oder zu anderen Zwecken aktuell oder
          künftig benötigt oder benötigen könnte, auf einem eigenen
          Speichermedium zu sichern und zu archivieren.
        </li>
      </ol>
      <h3 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">
        Löschen von Anzeigen, Sperrung von Nutzern, sonstige Maßnahmen
      </h3>
      <ol
        role="list"
        className="mt-8 space-y-2 text-gray-600 list-disc list-inside"
      >
        <li>
          <p className="mt-10 text-base leading-7 text-gray-700 ">
            Dealersonly.parts ist berechtigt, die eingestellte Anzeigen oder
            sonstige Inhalte des Nutzers ganz oder teilweise zu löschen oder die
            Veröffentlichung von Anzeigen oder sonstigen Inhalten des Nutzers zu
            verzögern oder nicht vorzunehmen, wenn konkrete Anhaltspunkte dafür
            vorliegen, dass die Anzeige oder der Inhalt gegen diese
            Nutzungsbedingungen oder gegen gesetzlichen Vorgaben verstößt, oder
            dass der Nutzer sonst schuldhaft vertragliche Pflichten verletzt
            hat.
          </p>
        </li>
        <li>
          <p className="mt-10 text-base leading-7 text-gray-700 ">
            Dealersonly.parts kann den Nutzer in einem solchen Fall außerdem
            verwarnen und/oder vorläufig oder dauerhaft von der Nutzung der
            Dienste ausschließen.
          </p>
        </li>
        <li>
          <p className="mt-10 text-base leading-7 text-gray-700 ">
            Dealersonly.parts ist berechtigt, die Zurverfügungstellung der
            Dienste ganz oder teilweise einzuschränken oder zu beenden sowie die
            Veröffentlichung von Anzeigen oder sonstigen Inhalten von Nutzern zu
            verzögern, wenn dies im Hinblick auf Kapazitätsbeschränkungen, die
            Sicherheit oder Integrität der Server oder zur Durchführung
            technischer Maßnahmen erforderlich ist, oder dies der
            ordnungsgemäßen oder verbesserten Erbringung der Leistungen dient
            (Wartungsarbeiten).
          </p>
        </li>
      </ol>
      <p className="mt-10 text-base leading-7 text-gray-700 ">
        Ergreift Dealersonly.parts eine der Maßnahmen, die zu Einschränkung,
        Sperrung oder Kündigung führen, haben Nutzer die Möglichkeit, den einer
        solchen Maßnahmen zugrunde liegenden Sachverhalt im Rahmen des internen
        Beschwerdemanagementverfahrens des Kundenservices von Dealersonly.parts
        abzusetzen.
      </p>
      <h3 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">
        Gebühren
      </h3>
      <ol
        role="list"
        className="mt-8 space-y-2 text-gray-600 list-disc list-inside"
      >
        <li>
          Für bestimmte, im Zusammenhang mit den Dealersonly.parts-Diensten
          erbrachte Leistungen und die Nutzung bestimmter Funktionen der
          Dealersonly.parts-Dienste erhebt Dealersonly.parts Gebühren. Dem
          Nutzer wird vor jeder Buchung einer kostenpflichtigen Leistung
          ausdrücklich auf die Kostenpflichtigkeit sowie auf die Höhe der
          anfallenden Kosten hinweisen.
        </li>
        <li>
          Von Dealersonly.parts für die Erbringung eigener Leistungen innerhalb
          der Dienste genannte Preise verstehen sich jeweils in Euro exklusive
          der gesetzlichen Umsatzsteuer (netto).
        </li>
        <li>
          Vereinbarte Entgelte sind jeweils monatlich zur Zahlung fällig und
          können über die akzeptierten Zahlungsmittel beglichen werden. Diese
          sind Banküberweisung oder Bankeinzug mittels SEPA-Lastschrift. Schlägt
          der Forderungseinzug fehl und hat der Nutzer das Fehlschlagen zu
          vertreten, hat der Verursacher die hierdurch entstandenen Mehrkosten
          zu tragen.
        </li>
        {/* <li>Für eingestellte Artikel berechnet Dealersonly.parts 5% des Verkaufswertes, bei Motorrädern und Rolling Chassis eine einmalige Gebühr von 50,00 Euros und jede eingestellte Suchanfrage kostet einmalig 8,90 Euros.</li> */}
      </ol>

      <h3 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">
        Haftung von Dealersonly.parts
      </h3>
      <ol
        role="list"
        className="mt-8 space-y-2 text-gray-600 list-disc list-inside"
      >
        <li>
          Die in den Dealersonly.parts -Diensten veröffentlichten Anzeigen und
          sonstigen Inhalte von Nutzern geben nicht die Meinung von
          Dealersonly.parts wieder und werden von Dealersonly.parts nicht auf
          ihre Rechtmäßigkeit, Richtigkeit und Vollständigkeit überprüft.
          Dealersonly.parts übernimmt keine Gewähr für die Richtigkeit und
          Vollständigkeit der in den Anzeigen enthaltenen Angaben und auch keine
          Gewähr für die Qualität, Sicherheit oder Rechtmäßigkeit der von
          Nutzern angebotenen Waren oder Dienstleistungen.
        </li>
      </ol>

      <h3 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">
        Beendigung des Nutzungsvertrages
      </h3>
      <ol
        role="list"
        className="mt-8 space-y-2 text-gray-600 list-disc list-inside"
      >
        <li>
          Der Nutzer kann den Nutzungsvertrag, soweit nicht anders vereinbart,
          schriftlich per Email an rasi1340@t-online.de jederzeit beenden ,
          jeweils zum nächsten Monatsanfang- Berechnungszeitraum
        </li>
        <li>
          Dealersonly.parts kann den Nutzungsvertrag jederzeit ordentlich zum
          jeweiligen Monatsende kündigen.
        </li>
        <li>
          Mit Beendigung des Nutzungsvertrages werden alle laufenden Anzeigen
          des Nutzers aus den Dealersonly.parts -Diensten entfernt und das
          Nutzerkonto des Nutzers deaktiviert. Ein Zugriff auf das Nutzerkonto
          durch den Nutzer besteht ab diesem Zeitpunkt nicht mehr. Das
          Nutzerkonto und alle dazu gespeicherten Daten des Nutzers werden
          spätestens sechs Monate nach Vertragsbeendigung gelöscht. Dies gilt
          nicht für Daten, zu deren Aufbewahrung Dealersonly.parts gesetzlich
          verpflichtet ist Aggregierte Daten, die durch die Nutzung generiert
          wurden, können grundsätzlich auch nach Vertragsende weiterhin
          aufbewahrt werden.
        </li>
        <li>
          Dealersonly.parts behält sich außerdem das Recht vor, Nutzerkonten mit
          unvollständigen Registrierungsdaten und Nutzerkonten, die für einen
          Zeitraum von mindestens 12 Monaten inaktiv waren, unwiderruflich zu
          deaktivieren und zu löschen. Dealersonly.parts wird den Nutzer
          mindestens 30 Tage vor Löschung des Nutzerkontos per Email eine
          entsprechnede Notiz zugesandt.
        </li>
      </ol>
    </div>
  );
};

export default AGB;
